@if (isLoaded) {
  <div
    class="bp-modal mod-lg"
    id="trade-savings-modal"
    [class.elevated]="!isThirdStep && !isTradableListSelection() && !isIntroductionStep"
    @openingClosingTrigger>
    @if (!showSmsPinVerification) {
      @if (!summary) {
        @if (currentStep; as header) {
          <bp-modal-header
            class="font-semibold"
            [step]="header.step"
            [title]="header.title"
            [showIndicator]="false">
            @if (header.left; as left) {
              <a
                left
                (click)="onHeaderButtonClick(left)"
                (keydown.enter)="onHeaderButtonClick(left)"
                [tabIndex]="0">
                {{ left | translate }}
              </a>
            }
            @if (header.right; as right) {
              <a
                right
                (click)="onHeaderButtonClick(right)"
                (keydown.enter)="onHeaderButtonClick(right)"
                [tabIndex]="0">
                {{ right | translate }}
              </a>
            }
          </bp-modal-header>
        }
        <!-- Content -->
        <div class="bp-modal-body">
          <div
            class="bp-modal-body-section"
					[ngClass]="{
						'mod-no-padding': getValidationShortcut(),
						'pb-0': isThirdStep,
						'min-h-400': isSecondStep && !getValidationShortcut(),
						'mod-no-padding': isTradableListSelection()
					}">
            <!-- Description: -->
            @if (userIsVerified() && !isTradableListSelection()) {
              <div
						[ngClass]="{
							'bp-modal-description': isFirstStep || isSecondStep || isIntroductionStep,
							'text-center pb-20 amount-description': isThirdStep
						}"
                >
                @if (isIntroductionStep) {
                  <h2 class="savings-modal-intro-title">{{
                    "recurring_buy_modal_intro_title" | translate
                  }}</h2>
                }
                @if (isFirstStep) {
                  {{ "buy_select_wallet_info_text" | translate }}
                }
                @if (isSecondStep) {
                  @if (userWantsSepaProvider() || getValidationShortcut()) {
                    <span>
                      {{ "recurring_buy_sepa_register_header" | translate }}
                    </span>
                  } @else {
                    <span>{{ "recurring_buy_modal_payment_currency_description" | translate }}</span>
                  }
                }
                @if (isThirdStep) {
                  {{ "recurring_buy_modal_amount_description" | translate: [getSelectedCurrencyName()] }}
                }
              </div>
            }
            <!-- Step 1: Asset currency select-->
            @if (userIsVerified()) {
              <!-- Step introduction: Savings plan introduction modal -->
              @if (isIntroductionStep) {
                <trade-savings-intro (onButtonClicked)="goToFirstStep()"></trade-savings-intro>
              }
              @if (isFirstStep) {
                <!-- legacy logic: with `tradableId` we communicate that we have multiple wallets -->
                <!-- `tradableId` = null -> we don't have multiple wallets -->
                <!-- `tradableId` != null -> we have multiple wallets -->
                @if (!tradableId) {
                  <savings-plan-asset-list (assetClicked)="onTradableSelect($event)">
                  </savings-plan-asset-list>
                }
                @if (tradableId) {
                  <tradable-wallet
                    [ngClass]="'modal-grid mod-two-cols'"
                    [action]="'savings-plan'"
                    [tradableWallets]="wallets"
                    (onSelect)="onWalletSelect($event)"
                    [(tradableId)]="tradableId">
                  </tradable-wallet>
                }
              }
            } @else {
              <div class="modal-add-info pt-10 pb-40">
                @if (!isVerificationPending()) {
                  <h3 class="modal-add-info-headline">
                    {{
                    (userIsDocumented()
                    ? "savings_plan_documented_user_description_action"
                    : "savings_plan_unverified_user_description_action"
                    ) | translate
                    }}
                  </h3>
                  <p class="modal-add-info-text text-narrowest center-block">
                    {{
                    (userIsDocumented()
                    ? "savings_plan_documented_user_description_text"
                    : "savings_plan_unverified_user_description_text"
                    ) | translate
                    }}
                  </p>
                  <button
                    class="modal-add-info-button btn btn-primary btn-inverse btn-bold btn-bigger-text"
                    (click)="verify()"
                    type="button">
                    <i class="bpi__icon-verify"></i>
                    {{
                    (userIsDocumented()
                    ? "verification_process_full_button"
                    : "start_verification_here_button"
                    ) | translate
                    }}
                  </button>
                } @else {
                  <h3 class="modal-add-info-headline">
                    {{ "modal_verification_progress_title" | translate }}
                  </h3>
                  <p class="modal-add-info-text text-narrow center-block">
                    {{ "modal_verification_progress_info" | translate }}
                  </p>
                }
              </div>
            }
            <!-- Step 2: Fiat currency + Fiat Wallet select -->
            @if (isSecondStep) {
              <!-- Currency dropdown -->
              @if (!getValidationShortcut()) {
                @if (userWantsSepaProvider()) {
                  <!-- Step 2: SEPA Register-->
                  <div class="modal-grid mod-two-cols">
                    @for (a of sepaAccounts$ | async; track a) {
                      <payment-tile
                        [ngClass]="'grid-item'"
                        (onClicked)="selectSepaAccount(a)"
                        [account]="a"
                        [deleteAllowed]="isDeleteSepaAllowed(a)"
                      (deleteAccount)="deleteAccount($event)"></payment-tile>
                    }
                    <payout-add-tile
                      [locaKey]="'payment_add_tile_button'"
                      [ngClass]="'grid-item'"
                    (clicked)="setValidationShortcut(true)"></payout-add-tile>
                  </div>
                } @else {
                  <div class="dropdown-container">
                    <bp-select
                      class="mb-5 dropdown-container__select"
                      [options]="fiatCurrencyOptions"
                      [(selectedValue)]="selectedFiat"
                      [bindLabel]="'name'"
                      [clearable]="false"
                      [searchable]="true"
                      [appendTo]="'#trade-savings-modal'"
                      [dropdownPosition]="'bottom'"
                      (selectedValueChange)="updateProviders()">
                    </bp-select>
                  </div>
                  <!-- Line delimiter -->
                  <hr class="mb-20 mt-20" />
                  <!-- Payment options (eg: VISA) -->
                  <!-- Active -->
                  <div class="modal-grid mod-two-cols">
                    @for (p of providerAvailable; track p; let i = $index) {
                      <provider-tile
                        [fiat]="selectedFiat"
                        [fiats]="fiats"
                        [ngClass]="'grid-item'"
                        [active]="isSame(p, savingsModel.paymentOption)"
                        (keydown.enter)="selectProvider(p)"
                        [tabIndex]="0"
                        (click)="selectProvider(p)"
                        [provider]="p"
                        [showOnlyPercentFees]="true">
                      </provider-tile>
                    }
                  </div>
                  <!-- Not active -->
                  <div class="modal-grid mod-two-cols">
                    @for (p of providerUnavailable; track p; let i = $index) {
                      <provider-tile
                        [disabled]="true"
                        [provider]="p"
                        [ngClass]="'grid-item'"
                        bp-tooltip="{{ 'unavailable_because_of_fiat' | translate }}"
                        position="top"
                        [tabindex]="0">
                      </provider-tile>
                    }
                  </div>
                }
              } @else {
                @if (getValidationShortcut()) {
                  <payment-account-detail
                    (finish)="onSepaCreated($event)"
                    (onReturn)="returnToProviders()"
                    >
                    <!-- #savings-specific account creation -->
                  </payment-account-detail>
                }
              }
            }
            <!-- Step 3: Amount - Preselected buttons (eg: 2 blue buttons + Max): -->
            @if (isThirdStep) {
              <div class="modal-grid mod-three-cols mod-in-modal mod-center">
                @for (amount of getFiatAmounts(); track amount) {
                  <fiat-amount-tile
                    [ngClass]="'grid-item'"
                    (click)="setFiatAmount(amount)"
                    [amount]="amount"
                    [fiat]="getFiat()"
                    [isSavings]="true">
                  </fiat-amount-tile>
                }
                @if (getMaxAmount() > 0) {
                  <fiat-amount-tile
                    (click)="setToMax()"
                    [ngClass]="'grid-item'"
                    [fiat]="getFiat()"
                    [amount]="getMaxAmount()"
                    [max]="'maximum' | translate"
                    [isSavings]="true"
                    [recurringFrequency]="getFrequencyString()">
                  </fiat-amount-tile>
                }
              </div>
            }
          </div>
          <!-- Step 3: Amount - Input, total, summary button: -->
          @if (isThirdStep) {
            <div
              class="bp-modal-body-section mod-fullwidth pt-30"
              [ngClass]="{ 'pb-15': showDerivativeFooter() }"
              >
              <!-- Input -->
              <div class="items-start flex-wrap modal-internal-transfer mod-input">
                <bp-input
                  class="mod-input-line"
                  iconLeading="true"
                  [type]="getSelectedCurrency()"
                  [iconUrl]="icon"
                  [iconUrlAltText]="'logo_alt_text' | translate"
                  min="0"
                  name="amount_fiat"
                  [step]="getStepsFromOfferFiat()"
                  required
                  autofocus
                  [(value)]="amount"
                  [formGroupClass]="false"
                  (onFocus)="inputOnFocus($event)"
                  bpInputNumberLeadingTrailingDot
                [disabled]="savingsModel.limitsExceeded"></bp-input>
              </div>
              <!-- Minimum -->
              <div class="mt-5 bp-modal-custom-margin modal-internal-transfer mod-input minimum-label">
                <span class="text-small-black input-label-minimum align-right minimum-label-text">
                  {{ "minimum" | translate }}:
                  {{ minLegacy | fiat_precision_symbol: { id: getFiat()?.getId(), currencies: [getFiat()] } }}
                </span>
                @if (aboveMaxLock) {
                  <span class="input-label-minimum minimum-label-error">
                    {{ "savings_error_amount_above_maximum" | translate }}
                  </span>
                }
              </div>
              <!-- Line delimiter -->
              <hr class="mb-20 mt-20" />
              <!-- Frequency label -->
              <div class="frequency-label modal-internal-transfer mod-input mb-10">
                {{ "recurring_buy_modal_frequency_label_frequency" | translate }}
              </div>
              <!-- Frequency selector -->
              @if (receivedFrequencies()) {
                <div class="modal-internal-transfer mod-input">
                  <bp-selector-frequency
                    [planFrequency]="savingsModel?.planExample?.getPlanFrequencies()"
                    [planInterval]="savingsModel?.planExample?.getInterval()"
                    (modelUpdate)="onFrequencyModelUpdate($event)"
                    [previousStoredModel]="getBpSelectorModel()">
                  </bp-selector-frequency>
                </div>
              }
              <!-- Buy details -->
              <div class="modal-internal-transfer mod-input pt-20 pb-20">
                <div class="plan-details">
                  <div class="plan-details__icon">
                    <div class="flex">
                      <img
                        [src]="getTradable().getLogo()"
                        class="icon-size-50"
                        (error)="img.src = getTradable().getDefaultLogo()"
                        alt="{{ 'logo_alt_text' | translate }}"
                        #img />
                    </div>
                  </div>
                  <div class="plan-details__text">
                    <div class="plan-details__text__currency">
                      @if (!getTradable().isToken()) {
                        <strong
                          >{{
                          "recurring_buy_modal_plan_details_cryptocurrency" | translate
                          }}
                          :</strong
                          >
                        } @else {
                          <strong> {{ "coin_name_label" | translate }} :</strong>
                        }
                        {{ getSelectedCurrencyName() }}
                      </div>
                      @if (showInitialBuyInfo) {
                        <div class="plan-details__text__initial">
                          <strong>{{ "recurring_buy_modal_plan_details_initial_buy" | translate }} :</strong>
                          {{ "recurring_buy_modal_plan_details_initial_buy_now" | translate }}
                          <!--{{getSelectedInitialBuy()}}-->
                        </div>
                      }
                      <div class="plan-details__text__next">
                        <strong>
                          {{ "recurring_buy_modal_plan_details_next_scheduled" | translate }} :
                        </strong>
                        {{ getNextScheduledBuy() }}
                        <span class="plan-details__text__next__utc">
                          ({{ savingsModel.getTimeZone() }} )
                        </span>
                      </div>
                      @if (showSepaLeadTimeWarning()) {
                        <div class="pt-5">
                          {{
                          "direct_debit_savings_plan_prior_deduction_info"
                          | translate: ["" + savingsModel?.planExample?.getLeadTimeDays()]
                          }}
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <!-- ITB -->
                <instant-trade-bonus [tradeData]="getItbData()" [isSaving]="true" [step]="getItbStep()">
                </instant-trade-bonus>
                <!-- Line delimiter -->
                <hr class="mb-20 mt-20" />
                <!-- Total amount -->
                <div class="pl-50 pr-50">
                  <div class="bp-modal-row">
                    <div class="bp-modal-column left mr-5 font-size-20">
                      {{ "recurring_buy_modal_total_amount" | translate }}
                    </div>
                    <div
                      class="bp-modal-column right break font-size-24"
								[ngClass]="{
									'total-amount': getAmountFiat() === 0
								}">
                      <strong>
                        {{
                        getAmountFiat()
                        | fiat_precision_symbol
                        : { id: getFiat()?.getId(), currencies: [getFiat()], symbol: true }
                        }}
                      </strong>
                    </div>
                  </div>
                </div>
                <!-- Go Summary button -->
                <div
                  class="pl-30 pr-30 mt-20 text-center focus-child"
                  (keydown.enter)="goToSummaryPressed()"
                  [tabIndex]="0">
                  <button
                    class="btn btn-primary btn-lg btn-summary mod-amount"
                    [disabled]="isSavingsDisabled()"
                    type="button"
                    (click)="goToSummaryPressed()">
                    {{ "goto_summary_trade_buy_button" | translate }}
                  </button>
                </div>
                @if (showDerivativeFooter()) {
                  <div class="trade-modal_powered_by_stocks">
                    {{ "stocks_powered_by" | translate }}
                  </div>
                }
              </div>
            }
          </div>
        } @else {
          @if (!showSmsPinVerification && !showMandateConfirmation) {
            <savings-summary
              [savingsData]="savingsModel"
              [data]="savingsModel.tradeData"
              (onClose)="close()"
              (edit)="setEdit($event)"
            (finish)="planConfirmed($event)"></savings-summary>
          }
        }
        <!-- Summary screen -->
      } @else {
        <bp-modal-header class="font-semibold" [title]="'recurring_buy_modal_title_confirm_savings_plan' | translate">
          <a right (click)="closeVerify()" (keydown.enter)="closeVerify()" [tabIndex]="0">{{
            "abort" | translate
          }}</a>
        </bp-modal-header>
        <div class="bp-modal-body">
          <div class="bp-modal-body-section min-h-400">
            <span class="bp-modal-body-2fa-deposit">
              <two-fa-verify-savings
                [savingsData]="savingsModel"
                (pinSentF)="pinSent = $event"
                [pinSent]="pinSent"
              (accept)="pinConfirmed($event)"></two-fa-verify-savings>
            </span>
          </div>
        </div>
      }
      <!--  Confirmation modal for new direct debit mandate  -->
      @if (showMandateConfirmation) {
        <confirm-mandate-modal
          [bankAccount]="selectedSepaAccount"
          [readonly]="false"
        (buttonClick)="mandateConfirmationModalAction($event)"></confirm-mandate-modal>
      }
      <!-- SMS PIN confirmation screen -->
    </div>
  }
